import Vue from 'vue'
import Router from 'vue-router'
import Other from './other'

Vue.use(Router)

const _import = require('./_import_' + process.env.NODE_ENV)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/welcome',
      name: 'Welcome',
      component: _import('Welcome'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/task', //报告中心
      name: 'Task',
      component: _import('Task'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/report',
      name: 'Report',
      component: _import('report/Index'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    // {
    //   path: '/compositionreport',
    //   name: 'compositionreport',
    //   component: _import('report/compositionIndex'),
    //   meta: {
    //     permission: false,
    //     allowBack: false,
    //     noCache: true
    //   }
    // },
    {
      path: '/report/detail',
      name: 'ReportDetail',
      component: _import('report/Details'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/mobileList',
      name: 'MobileList',
      component: _import('mobile/Lists'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/mobilesubject',
      name: 'MobileSubject',
      component: _import('mobile/Subject'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/mobile/video', // 知识点视频
      name: 'MobileVideo',
      component: _import('mobile/Video'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/mobile/viewVideo',
      name: 'MobileViewVideo',
      component: _import('mobile/components/ViewVideo'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/mobile/knowledgeNotes',
      name: 'MobileKnowledgeNotes',
      component: _import('mobile/components/KnowledgeNotes'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/mobile/Details',
      name: 'MobileDetails',
      component: _import('mobile/Details'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/challquestion',
      component: _import('allquestion/Index'),
      name: 'challquestion',
      meta: {
        socket: false,
        permission: false,
      }
    },
    {
      path: '*',
      component: _import('NotFound'),
    }, /*默认跳转路由*/
    Other,
    {
      path: "/comparative",
      name: "Comparative",
      component: _import('comparative/Index'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: '/mobileUpload',
      name: 'mobileUpload',
      component: () => import('../components/auxiliaryInput/Upload.vue'),
      meta: {
        permission: false,
        allowBack: false,
        noCache: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js